import { orderRoutes } from '~/shared/constants/orderRoutes';
import { programRoutes } from '~/shared/constants/programRoutes';
import { ETolgeeHome } from '~/shared/enums/ETolgeeHome';

import { HomeActionCardTemplate } from '../types';

export const HOME_ACTION_CARD_TEMPLATES = {
  configuration: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_PROGRAM_SALES_TITLE,
    descriptionKey:
      ETolgeeHome.HOME_SHORTCUTS_PROGRAM_CONFIGURATION_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_PROGRAM_CONFIGURATION_BUTTON,
    badge: {
      labelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BADGE_CONFIGURATION,
      variant: 'neutral'
    },
    getHref: (programId?: number) =>
      programId ? `${programRoutes.update}?id=${programId}` : programRoutes.list
  },
  stockValidationDone: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_PROGRAM_SALES_TITLE,
    descriptionKey:
      ETolgeeHome.HOME_SHORTCUTS_STOCK_VALIDATION_DONE_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BUTTON_STOCK_VALIDATION,
    badge: {
      labelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BADGE_STOCK_VALIDATION,
      variant: 'warning'
    },
    descriptionTitleKey:
      ETolgeeHome.HOME_SHORTCUTS_STOCK_VALIDATION_DONE_DESCRIPTION_TITLE,
    getHref: (programId?: number) =>
      programId ? `/stock-validation/${programId}` : programRoutes.list
  },
  stockValidationPending: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_PROGRAM_SALES_TITLE,
    descriptionKey:
      ETolgeeHome.HOME_SHORTCUTS_STOCK_VALIDATION_PENDING_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BUTTON_STOCK_VALIDATION,
    badge: {
      labelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BADGE_STOCK_VALIDATION,
      variant: 'warning'
    },
    descriptionTitleKey:
      ETolgeeHome.HOME_SHORTCUTS_STOCK_VALIDATION_PENDING_DESCRIPTION_TITLE,
    getHref: (programId?: number) =>
      programId ? `/stock-validation/${programId}` : programRoutes.list
  },
  stockValidationNotify: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_PROGRAM_SALES_TITLE,
    descriptionKey:
      ETolgeeHome.HOME_SHORTCUTS_STOCK_VALIDATION_NOTIFY_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BUTTON_NOTIFY_PENDING,
    badge: {
      labelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BADGE_STOCK_VALIDATION,
      variant: 'warning'
    },
    getHref: (programId?: number) =>
      programId
        ? `${programRoutes.ongoing}?id=${programId}`
        : programRoutes.list
  },
  productSalesNotify: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_PROGRAM_SALES_TITLE,
    descriptionKey: ETolgeeHome.HOME_SHORTCUTS_SALES_PERIOD_NOTIFY_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BUTTON_NOTIFY_PENDING,
    badge: {
      labelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BADGE_PRODUCT_SALES,
      variant: 'info'
    },
    getHref: (programId?: number) =>
      programId ? `${programRoutes.ongoing}?id=${programId}` : '/orders'
  },
  teamOrders: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_TEAM_ORDERS_TITLE,
    descriptionKey: ETolgeeHome.HOME_SHORTCUTS_TEAM_ORDERS_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BUTTON_PLACE_ORDER,
    getHref: () => orderRoutes.teamOrders
  },
  myOrder: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_MY_ORDER_TITLE,
    descriptionKey: ETolgeeHome.HOME_SHORTCUTS_MY_ORDER_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BUTTON_PLACE_ORDER,
    getHref: () => '/orders'
  },
  programClosing: {
    titleKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_PROGRAM_SALES_TITLE,
    descriptionKey: ETolgeeHome.HOME_SHORTCUTS_PROGRAM_CLOSING_DESCRIPTION,
    actionLabelKey: ETolgeeHome.HOME_SHORTCUTS_PROGRAM_CLOSING_BUTTON,
    badge: {
      labelKey: ETolgeeHome.HOME_SHORTCUTS_COMMON_BADGE_CLOSING,
      variant: 'neutral'
    },
    getHref: (programId?: number) =>
      programId ? `${programRoutes.closing}/${programId}` : programRoutes.list
  }
} satisfies Record<string, HomeActionCardTemplate>;
